import {AnalyticsService} from 'src/features/erp-sutor/features/analytics';
import {AttendanceCalendarDataService, AttendanceCalendarService} from 'src/features/erp-sutor/features/attendance-calendar';
import {dataViewRoutes, MonthAttendanceService} from 'src/features/erp-sutor/features/data-view-page';
import {HomepageDataService, HomepageService} from 'src/features/erp-sutor/features/homepage-detail';
import {EmployeeRecordDetailDataService, EmployeeRecordDetailService} from 'src/features/erp-sutor/features/employee-record-detail';
import {ReportReferencesDataService, reportReferencesRoutes, ReportReferencesService} from 'src/features/erp-sutor/features/report-references-page';
import {reportProcessingRoutes, ReportProcessingService} from 'src/features/erp-sutor/features/report-processing-page';
import {ProjectFinancialOverviewDataService, ProjectFinancialOverviewService} from 'src/features/erp-sutor/features/project-financial-overview';
import {ProjectReportOptimisationDataService, ProjectReportOptimisationService} from 'src/features/erp-sutor/features/project-report-optimisation';
import {ProjectLogbookPairingService} from 'src/features/erp-sutor/features/project-logbook-pairing';
import {reportApprovingRoutes, ReportApprovingService} from 'src/features/erp-sutor/features/report-approving-page';
import {ReportDetailDataService, ReportDetailService} from 'src/features/erp-sutor/features/report-detail';
import register from '@kpsys/angularjs-register';

export default register('portaro.features.erp-sutor', ['ui.router'])
    // Work attendance calendar
    .service(AttendanceCalendarDataService.serviceName, AttendanceCalendarDataService)
    .service(AttendanceCalendarService.serviceName, AttendanceCalendarService)

    // Data-view
    .config(dataViewRoutes)

    // Landing
    .service(HomepageDataService.serviceName, HomepageDataService)
    .service(HomepageService.serviceName, HomepageService)

    // Report references
    .config(reportReferencesRoutes)
    .service(ReportReferencesDataService.serviceName, ReportReferencesDataService)
    .service(ReportReferencesService.serviceName, ReportReferencesService)

    // Report detail
    .service(ReportDetailDataService.serviceName, ReportDetailDataService)
    .service(ReportDetailService.serviceName, ReportDetailService)

    // Report reference processing
    .config(reportProcessingRoutes)
    .service(ReportProcessingService.serviceName, ReportProcessingService)

    // Reports approving
    .config(reportApprovingRoutes)
    .service(ReportApprovingService.serviceName, ReportApprovingService)

    // Project record detail
    .service(ProjectFinancialOverviewDataService.serviceName, ProjectFinancialOverviewDataService)
    .service(ProjectFinancialOverviewService.serviceName, ProjectFinancialOverviewService)

    // Analytics
    .service(AnalyticsService.serviceName, AnalyticsService)

    // Report optimisation
    .service(ProjectReportOptimisationDataService.serviceName, ProjectReportOptimisationDataService)
    .service(ProjectReportOptimisationService.serviceName, ProjectReportOptimisationService)

    // Logbook pairing
    .service(ProjectLogbookPairingService.serviceName, ProjectLogbookPairingService)

    // Month attendance
    .service(MonthAttendanceService.serviceName, MonthAttendanceService)

    // Employee detail
    .service(EmployeeRecordDetailDataService.serviceName, EmployeeRecordDetailDataService)
    .service(EmployeeRecordDetailService.serviceName, EmployeeRecordDetailService)

    .name();